import React from 'react';

function Customers() {
  return (
    <div>
        Welcome to Customer Component.
    </div>
  );
}

export default Customers;
